// List of session-related actions.  All scoped with 'SESSION:'
const ACTIONS = {
  LOGOUT: 'SESSION:LOGOUT'
};

export const logOut = () => ({
  type: ACTIONS.LOGOUT
});

export default ACTIONS;



// WEBPACK FOOTER //
// ./src/session/actions.js